module.exports = __webpack_public_path__ + "img/section30.36ba0820.png";